<template>
	<div class="header-warp">
		<ul>
			<template v-for="(item, index) in title">
				<li :key="item">
					<p><img :src="require(`@comm/images/document-conversion/electronic/flow${active}${index}.png`)" alt="flow" /></p>
					<p>{{ `${index + 1}.${item}` }}</p>
				</li>
				<li :key="index" v-if="index != 3"><el-divider class="head-divider" /></li>
			</template>
		</ul>
	</div>
</template>

<script>
export default {
	name: "ContantHead",
	props: {
		title: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		active() {
			return this.$store.getters.activeModel;
		}
	}
};
</script>

<style lang="scss" scoped>
.header-warp {
	padding: 64px 21px 0;
	width: 100%;
	overflow: hidden;
	ul {
		width: 100%;
		height: auto;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: space-around;

		li {
			float: left;
			height: 90px;
			text-align: center;
			width: 150px;

			p {
				white-space: nowrap;
				font-size: 16px;
				color: #36425a;
			}
			img{
				width: 48px;
				height: auto;
			}
		}

		& > li:nth-child(2n+1) {
			width: 154px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
	}
}
.head-divider {
	background-color: #14a8f0;
	margin: 40px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/components/ContantHead.vue